ready().then(function() {

    const pageTemplates = ['single-post', 'single-wpg_attachment', 'single-wpg_event', 'page-template-default'];

    // based on page template
    for ( var i = 0; i < pageTemplates.length; i++ ) {
        if ( $('body').hasClass( pageTemplates[i] )) {
        
            /**
             * Change the mobile layout
             */
            const reorderMobileElements = () => {

                const infoContainer = $('.info-container .ui-container');
                const coverimg = $('.info-img-container img');
                const postsummary = $('.info-section .info-bio');
                const pageTitle = $('.section-post-info.has-custom-img .page-title');
                const pageMeta = $('.section-post-info.has-custom-img .post-meta');

                if(pageMeta.length > 0) {
                    infoContainer.prepend(pageMeta);
                }

                if(pageTitle.length > 0) {
                    infoContainer.prepend(pageTitle);
                }

                if(coverimg.length > 0) {
                    postsummary.prepend(coverimg);
                    coverimg.wrap('<div class="info-img-container"></div>')
                }
            }

            if (window.screen.width < mdWidth ) { // Only on the smallest devices
                reorderMobileElements();
            }
        }
    }
});